import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';

export default function BasicPagination({ count, onChange = () => {}, resetpage, reverse = false }) {
  const [page, setPage] = React.useState(resetpage || 1);
  const handleChange = (event, value) => {
    setPage(value);
    onChange(value);
  };

  // When `reverse` is true we only flip the *label* shown on the page-number
  // buttons (e.g. with count=12 → 12,11,…,1). The internal page value passed
  // to onChange stays normal, so page 1 still fetches the latest items.
  const renderItem = reverse
    ? (item) => {
        if (item.type === 'page' && typeof item.page === 'number') {
          return <PaginationItem {...item} page={count - item.page + 1} />;
        }
        return <PaginationItem {...item} />;
      }
    : undefined;

  return (
    <Stack spacing={2}>
      <Pagination
        count={count}
        color="primary"
        page={page}
        onChange={handleChange}
        renderItem={renderItem}
      />
    </Stack>
  );
}
